import { render, staticRenderFns } from "./AdministratorDataForm.vue?vue&type=template&id=4e96fde3&"
import script from "./AdministratorDataForm.vue?vue&type=script&lang=js&"
export * from "./AdministratorDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports